import {
	SovosBox,
	SovosButton,
	SovosCircularProgress,
	SovosTypography,
} from 'mosaic-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const FormStepLayout: React.FC<{
	title: string;
	subTitle?: React.ReactNode;
	errors?: string[];
	showErrors?: boolean;
	isLoading?: boolean;
	onContinue: () => void;
	onCancel?: () => void;
	continueButton?: React.ReactNode;
	children: React.ReactNode;
}> = ({
	title,
	subTitle,
	errors,
	showErrors,
	isLoading,
	onContinue,
	onCancel,
	continueButton,
	children,
}) => {
	const navigate = useNavigate();

	return (
		<>
			{showErrors && errors && errors.length > 0 && (
				<SovosBox
					component='ul'
					sx={{
						width: '100%',
						color: 'error.main',
						bgcolor: 'rgba(219, 50, 45, 0.08)',
						px: 2,
						py: 1.5,
						mt: 1,
						mb: 3,
						borderRadius: 1,
						typography: 'body1',
						'& > li': {
							color: 'error.dark',
							listStylePosition: 'inside',
							my: 0.5,
						},
					}}
				>
					{errors.map((error) => (
						<SovosBox key={error} component='li'>
							{error}
						</SovosBox>
					))}
				</SovosBox>
			)}

			<SovosBox sx={{ pb: 2 }}>
				<SovosTypography variant='h5'>{title}</SovosTypography>
				{subTitle && <SovosTypography>{subTitle}</SovosTypography>}
			</SovosBox>
			{children}
			<SovosBox display='flex' py={2}>
				<SovosButton
					onClick={() => {
						if (onCancel) {
							onCancel();
						} else {
							navigate('..', { relative: 'path' });
						}
					}}
					variant='text'
					sx={{ mr: 1 }}
				>
					Cancel
				</SovosButton>
				{continueButton || (
					<SovosButton disabled={isLoading} onClick={onContinue}>
						{isLoading ? <SovosCircularProgress size={20} /> : 'Continue'}
					</SovosButton>
				)}
			</SovosBox>
		</>
	);
};

export default FormStepLayout;
